import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    // add slice reducers here
  },
});
